import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Button } from 'reactstrap';
import { Link } from 'site-modules/shared/components/link/link';
import { ScrollLink } from 'site-modules/shared/components/scroll-link/scroll-link';
import browseIllustration from './browse-illustration.svg';
import loanIllustration from './loan-illustration.svg';
import sellForCashIllustration from './sell-for-cash-illustration.svg';

import './car-equity-module.scss';

const CARDS_CONTENT = [
  {
    title: 'Sell your car and get paid',
    subtitle: `Confirm your car's value before you sell or trade.`,
    img: sellForCashIllustration,
    ctaText: (
      <Fragment>
        <span>See my car&apos;s value</span>
        <span className="icon-new-tab d-inline-block ms-0_5" aria-label="Open in a new tab" />
      </Fragment>
    ),
    isNewTab: true,
    getLink: ({ vin }) => `/sell-car/${vin ? `?vin=${vin}` : ''}`,
    trackingId: 'car_equity_sell_my_car',
    imgHeight: 189,
  },
  {
    title: 'Browse upgrades by Payment',
    subtitle: 'Use our calculator to see cars in your price range.',
    img: browseIllustration,
    ctaText: (
      <Fragment>
        <span>Customize payments</span>
        <span className="icon-arrow-down8 d-inline-block ms-0_5" aria-label="Open in a new tab" />
      </Fragment>
    ),
    getLink: () => 'affortability-calculator',
    trackingId: 'car_equity_customize_payments',
    imgHeight: 186,
    isScroll: true,
  },
  {
    title: 'Get pre-qualified for financing',
    subtitle: 'Get financing results without impacting your credit.',
    img: loanIllustration,
    ctaText: (
      <Fragment>
        <span>Get pre-qualified</span>
        <span className="icon-new-tab d-inline-block ms-0_5" aria-label="Open in a new tab" />
      </Fragment>
    ),
    isNewTab: true,
    getLink: () => 'https://www.carmax.com/pre-qual/app/landing?op=edmunds_email',
    trackingId: 'car_equity_get_prequalified',
    imgHeight: 161,
  },
];

export const CarEquityModule = ({ vin = null }) => (
  <Container
    className="car-equity-module bg-white px-md-2 pt-md-2 pb-md-3 px-1 mb-2"
    data-tracking-parent="ways_to_use_equity"
  >
    <h2 className="text-center size-36 text-cool-gray-10 mb-2_5 fw-bold">Three Ways to Use Your Car&apos;s Equity</h2>
    <Row>
      {CARDS_CONTENT.map(card => (
        <Col key={card.trackingId} xs={12} lg={4} className="car-equity-card">
          <div className="car-equity-card-content h-100 d-flex flex-column text-center px-1_5 py-1_5 py-lg-0">
            <div className="img-wrapper mb-1_5">
              <img height={card.imgHeight} src={card.img} alt="" />
            </div>
            <h3 className="size-24 text-cool-gray-30 fw-bold mb-0_5">{card.title}</h3>
            <p className="flex-grow-1 size-16 text-cool-gray-30 mb-1_5">{card.subtitle}</p>
            <Button
              className="cta d-flex align-items-center justify-content-center py-1 px-1_5 text-white text-transform-none fw-medium size-16"
              color="blue-50"
              tag={card.isScroll ? ScrollLink : Link}
              to={card.getLink({ vin })}
              data-tracking-id={card.trackingId}
              target={card.isNewTab ? '_blank' : undefined}
            >
              {card.ctaText}
            </Button>
          </div>
        </Col>
      ))}
    </Row>
  </Container>
);

CarEquityModule.propTypes = {
  vin: PropTypes.string,
};
